export function initItemCounter() {
  let obj = {};
  const updateItemListeners = [];
  const updateCounterListeners = [];

  return {
    onUpdatedItem: (fn) => {
      updateItemListeners.push(fn);
    },
    onUpdatedCounter: (fn) => {
      updateCounterListeners.push(fn);
    },
    increase,
    decrease,
    total,
    clear,
    asArray,
  };

  function emitOnUpdateItem(id, count) {
    updateItemListeners.forEach((fn) => fn(id, count));
  }

  function emitOnUpdateCounter() {
    updateCounterListeners.forEach((fn) => fn());
  }

  function increase(id) {
    if (obj[id]) {
      obj[id] += 1;
    } else {
      obj[id] = 1;
    }
    emitOnUpdateItem(id, obj[id]);
    emitOnUpdateCounter();
  }

  function decrease(id) {
    if (obj[id]) {
      obj[id] = Math.max(0, obj[id] - 1);
    } else {
      obj[id] = 0;
    }
    emitOnUpdateItem(id, obj[id]);
    emitOnUpdateCounter();
  }

  function total() {
    return Object.keys(obj).reduce((acc, id) => acc + obj[id], 0);
  }

  function asArray(type = 'string') {
    return Object.keys(obj).reduce((acc, id) => {
      const elements = Array(obj[id]).fill(transform(id));
      return [...acc, ...elements];
    }, []);

    function transform(id) {
      if (type === 'number') return Number(id);
      return id;
    }
  }

  function clear() {
    Object.keys(obj).forEach((id) => emitOnUpdateItem(id, 0));
    obj = {};
    emitOnUpdateCounter();
  }
}
